<template>
  <div>

    <!-- Time stats -->
    <div class="vx-row" style="display: none;">
      <div class="vx-col w-full mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse lg:flex-row">

            <!-- LEFT COL -->
            <div class="vx-col w-full lg:w-1/3 xl:w-1/4 flex flex-col justify-between">
              <div>
                <h2 class="mb-1 font-bold">De 10 a 10:30</h2>
                <span class="font-medium">El horario más usado</span>
                <!-- <p class="mt-2 text-xl font-medium"><span class='text-success'>+5.2%</span> vs last 7 days</p> -->
              </div>
              <!-- <vs-button icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full lg:mt-0 mt-4">
                View Details
              </vs-button> -->
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col w-full lg:w-2/3 xl:w-3/4 flex flex-col lg:mb-0 mb-base">
              <!-- <change-time-duratioChangeTimeDurationDropdownn-dropdown class="self-end" /> -->
              <vue-apex-charts type=bar height=200
              :options="analyticsData.timePreferences.chartOptions"
              :series="analyticsData.timePreferences.series" />
            </div>

          </div>
        </vx-card>
      </div>
    </div>


    <div class="vx-row mt-base">

      <div class="vx-col w-full md:w-1/2 lg:mt-0 mb-base">
        <vx-card title="Facturación diaria">
          <!-- SLOT = ACTIONS -->
          <template slot="actions">
            <change-day @changeDay="dailySalesDaysOfDiference = $event; dailySales()"/>
          </template>

          <div slot="no-body">
            <div class="mt-3" style="margin-left: 21px; font-size: 16px;">
            <b>Total:</b> {{ statsData.DailySalesTotal.invoicing | pricing }}
            - ({{ statsData.DailySalesTotal.sales }} ventas)
            </div>
            <!-- CHART -->
            <vue-apex-charts v-if="statsData.DailySalesTotal.sales" type="pie" height="196" class="mt-10 mb-10"
            :options="analyticsData.diarySales.chartOptions"
            :series="analyticsData.diarySales.series"
            />
            <div v-else class="noChartMsg">
              <div v-if="!analyticsData.diarySales.selectedDate">
                Aun no hay ventas hoy
              </div>
              <div v-else>
                El día seleccionado no hubo ventas
              </div>
            </div>
            <div class="w-full pr-5 pb-2" style="display: flex; justify-content: flex-end">
              <vs-checkbox v-model="isDiarySalesOnlyEntregado" @change="dailySales()">Solo los cobrados</vs-checkbox>
            </div>
            <!-- CHART DATA -->
            <ul class="mb-1">
              <li v-for="diarySales in analyticsData.diarySales.analyticsData"
              :key="diarySales.paymentType"
              class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                <span class="flex items-center">
                  <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${diarySales.color}`"></span>
                  <span class="font-semibold">{{ diarySales.paymentType }}</span>
                </span>
                <span>{{ diarySales.counts }}</span>
              </li>
            </ul>
          </div>
        </vx-card>
      </div>

      <!-- Objetivo facturación diaria -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card title="Objetivo facturación diaria">
          <template slot="actions">
            <change-time-day-dropdown />
          </template>
          <!-- CHART -->
          <template slot="no-body">
            <div class="mt-10">
              <vue-apex-charts type=radialBar height=240
              :options="analyticsData.averageInvoicing.chartOptions"
              :series="analyticsData.averageInvoicing.series"
              />
            </div>
          </template>
          <!-- DATA -->
          <div class="flex justify-between text-center" slot="no-body-bottom">
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
              <p class="mt-4">Facturacion del día</p>
              <p class="mb-4 text-3xl font-semibold">{{ statsData.DailySalesTotal.invoicing | pricing }}</p>
            </div>
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
              <p class="mt-4">Facturación diaria promedio</p>
              <p class="mb-4 text-3xl font-semibold">{{ statsData.DailySalesAverage.invoicing | pricing }}</p>
            </div>
          </div>
        </vx-card>
      </div>

      <!-- Clientes totales -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
        :chartData="analyticsData.subscribersGained"
        statisticTitle="Clientes totales"
        :statistic="statsData.totalBuyers | k_formatter"
        icon="UserIcon"
        type="area">
        </statistics-card-line>
      </div>

      <!-- Facturación total -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
        :chartData="analyticsData.revenueGenerated"
        statisticTitle="Facturación total"
        :statistic="statsData.Invoicing.total | k_formatter"
        icon="DollarSignIcon"
        color="success"
        type="area">
        </statistics-card-line>
      </div>

      <!-- Ventas totales -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
        :chartData="analyticsData.quarterlySales"
        statisticTitle="Ventas totales"
        :statistic="statsData.totalPurchases | k_formatter"
        icon="ShoppingCartIcon"
        color="danger"
        type="area">
        </statistics-card-line>
      </div>

      <!-- Productos vendidos -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
        :chartData="analyticsData.ordersRecevied"
        statisticTitle="Productos vendidos"
        :statistic="statsData.totalProductsPurchased | k_formatter"
        icon="ShoppingBagIcon"
        color="warning"
        type="area">
        </statistics-card-line>
      </div>
    </div>

    <div class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full md:w-3/3 mb-base">
        <vx-card title="Facturación">
          <template slot="actions">
            <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div slot="no-body" class="p-6 pb-0">
            <div class="flex">
              <div class="mr-6">
                <p class="mb-1 font-semibold">Este mes</p>
                <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ statsData.Invoicing.actualMonth }}</p>
              </div>
              <div>
                <p class="mb-1 font-semibold">Mes anterior</p>
                <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ statsData.Invoicing.lastMonth }}</p>
              </div>
            </div>
            <vue-apex-charts type=line height=266 :options="analyticsData.revenueComparisonLine.chartOptions" :series="analyticsData.revenueComparisonLine.series" />
          </div>
        </vx-card>
      </div>
    </div>



    <!-- ACA IRIA -->


    <div class="vx-row">

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
        :chartData="analyticsData.revenueGenerated"
        statisticTitle="Promedio ventas"
        :statistic="statsData.averagePurchase"
        icon="DollarSignIcon"
        color="success"
        type="area">
        </statistics-card-line>
      </div>


      <!-- OBJETIVOS -->
      <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card title="Resumen objetivos">
          <template slot="actions">
            <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <!-- CHART -->
          <template slot="no-body">
            <div class="mt-10">
              <vue-apex-charts type=radialBar height=240
              :options="analyticsData.goalOverviewRadialBar.chartOptions"
              :series="analyticsData.goalOverviewRadialBar.series"
              />
            </div>
          </template>
          <!-- DATA -->
          <div class="flex justify-between text-center" slot="no-body-bottom">
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
              <p class="mt-4">Sucursales hechas</p>
              <p class="mb-4 text-3xl font-semibold">1</p>
            </div>
            <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
              <p class="mt-4">Meta sucursales</p>
              <p class="mb-4 text-3xl font-semibold">10</p>
            </div>
          </div>
        </vx-card>
      </div>


      <!-- PAYMENT TYPE -->
      <div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
        <vx-card title="Pagos">
          <!-- SLOT = ACTIONS -->
          <template slot="actions">
            <change-time-duration-dropdown />
          </template>

          <div slot="no-body">
            <!-- CHART -->
            <vue-apex-charts type=pie height=345 class="mt-10 mb-10"
            :options="analyticsData.paymentType.chartOptions"
            :series="analyticsData.paymentType.series"
            />
            <!-- CHART DATA -->
            <ul class="mb-1">
              <li v-for="paymentType in analyticsData.paymentType.analyticsData"
              :key="paymentType.customerType"
              class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                <span class="flex items-center">
                  <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${paymentType.color}`"></span>
                  <span class="font-semibold">{{ paymentType.customerType }}</span>
                </span>
                <span>{{ paymentType.counts }}</span>
              </li>
            </ul>
          </div>
        </vx-card>
      </div>
    </div> <!-- vx-row -->



    <!-- PAYMENT TYPE -->
    <div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
      <vx-card title="Capital total en Stock">

          <h3 class="text-center py-5">${{ addPoints(totalStockPrice) }}</h3>

      </vx-card>
    </div>






          <!-- Sessions By Device -->
          <div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base" style="display: none">
            <vx-card title="Usos por dispositivo">
              <!-- SLOT = ACTIONS -->
              <template slot="actions">
                <change-time-duration-dropdown />
              </template>

              <div slot="no-body">
                <vue-apex-charts class="mt-6 mb-8" type=donut height=325 :options="analyticsData.sessionsByDeviceDonut.chartOptions" :series="analyticsData.sessionsByDeviceDonut.series" />
              </div>

              <ul class="mt-6">
                <li v-for="deviceData in analyticsData.sessionsByDeviceDonut.analyticsData" :key="deviceData.device" class="flex mb-3">
                  <feather-icon :icon="deviceData.icon" :svgClasses="[`h-5 w-5 stroke-current text-${deviceData.color}`]"></feather-icon>
                  <span class="ml-2 inline-block font-semibold">{{ deviceData.device }}</span>
                  <span class="mx-2">-</span>
                  <span class="mr-4">{{ deviceData.sessionsPercentgae }}%</span>
                  <div class="ml-auto flex -mr-1">
                    <span class="mr-1">{{ deviceData.comparedResultPercentage }}%</span>
                    <feather-icon :icon=" deviceData.comparedResultPercentage < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[deviceData.comparedResultPercentage < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
                  </div>
                </li>
              </ul>
            </vx-card>
          </div>




  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
// import statsItems from "./components/statsItems.js";
import analyticsData from './ui-elements/card/analyticsData.js'

export default{
  components: {
    StatisticsCardLine: () => import('@/../../Dual/components/statistics-cards/StatisticsCardLine.vue'),
    ChangeTimeDurationDropdown: () => import('@/../../Dual/components/ChangeTimeDurationDropdown.vue'),
    ChangeTimeDayDropdown: () => import('@/../../Dual/components/ChangeTimeDayDropdown.vue'),
    ChangeDay: () => import('@/../../Dual/components/ChangeDay.vue'),
    VueApexCharts,
  },
  data() {
    return {
      // staticsItems: sidebarItems,
      totalStockPrice: 0,
      statsData: {
        averagePurchase: 0,
        totalBuyers: 0,
        totalPurchases: 0,
        totalProductsPurchased: 0,
        DailySalesTotal: { invoicing: 0.0, sales: 0, },
        DailySalesAverage: { invoicing: 0.0, sales: 0, },
        daysOpened: 0,
        Invoicing: {
          total: 0,
          actualMonth: 0,
          lastMonth: 0,
        }
      },
      Sales: [],
      dailySalesDaysOfDiference: 0,
      isDiarySalesOnlyEntregado: false,
      analyticsData: analyticsData,
    }; // return DATA
  }, // DATA
  filters: {

  },
  created() {
    // this.calculateBuyers();
    this.calculateSales();
    this.calcultateTotalStock();
  }, // CREATED
  methods: {
    addPoints(val) {
      val = this.showPrice(val);
      val = String(val).replace('.', ',');
      let reversedVal = this.reverseString(val);
      let reversedRealVal = '';
      for (var i = 0; i < reversedVal.length; i++) {
        reversedRealVal += reversedVal.charAt(i);
        if (!((i-2) % 3) && i != 0) reversedRealVal += '.';
      }
      let finalValue = this.reverseString(reversedRealVal);
      return finalValue;
    },
    reverseString(str) {
      str = String(str);
      // Step 1. Use the split() method to return a new array
      var splitString = str.split(""); // var splitString = "hello".split("");
      // ["h", "e", "l", "l", "o"]

      // Step 2. Use the reverse() method to reverse the new created array
      var reverseArray = splitString.reverse(); // var reverseArray = ["h", "e", "l", "l", "o"].reverse();
      // ["o", "l", "l", "e", "h"]

      // Step 3. Use the join() method to join all elements of the array into a string
      var joinArray = reverseArray.join(""); // var joinArray = ["o", "l", "l", "e", "h"].join("");
      // "olleh"

      //Step 4. Return the reversed string
      return joinArray; // "olleh"
    },

    calculateBuyers() {
      const vm = this;
      this.conectToDB({
        file: 'Buyers', action: 'getBuyer', params: { isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.statsData.totalBuyers = res.data.data.length;
        },
      });
    },
    calculateSales() {
      const vm = this;
      this.conectToDB({
        // file: 'Sales', action: 'getSale', params: { stateID: this.SaleStates.Entregado },
        file: 'Sales', action: 'getSale', params: { noStateID: this.dataDB.SaleStateIDs.Cancelado },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          let Sales = res.data.data;
          vm.Sales = Sales;
          let totalAmountPurchases = Sales.length;
          let totalInvoicing = 0;
          let averagePurchase = 0;
          let actualMonthInvoicing = 0;
          let lastMonthInvoicing = 0;
          let actualMonth = vm.getActualMonth();
          let actualDayOfMonth = vm.getActualDayOfMonth();
          let lastMonth = vm.getActualMonth({ month: -1 });
          let DayInvoicing = { actualMonth: [], lastMonth: [], }
          let DailySales = {
            Efectivo:    { invoicing: 0.0, sales: 0, },
            Tarjeta:     { invoicing: 0.0, sales: 0, },
            Mercadopago: { invoicing: 0.0, sales: 0, },
          }
          let paymentType = [
            0, // efectivo
            0, // tarjeta
            0, // mercadopago
            0, // Qr
          ];
          let daysOpened = 0;
          for (var i = 0; i <= 30; i++) {
            DayInvoicing.actualMonth[i] = 0;
            DayInvoicing.lastMonth[i] = 0;
          }
          let lastDate = '';
          for (let Sale of Sales) {
            let newDate = vm.getDayOfDB(Sale.date);
            if (newDate != lastDate) {
              daysOpened++;
              lastDate = newDate;
            }
            // paymentType
            paymentType[Sale.paymentTypeID-1]++;
            let dayOfMonth = vm.getDayOfDB(Sale.receptionDate);
            // vm.calculateProducts(Sale.id);
            // Actual month
            if (actualMonth == vm.getMonthOfDB(Sale.receptionDate)) {
              actualMonthInvoicing += Sale.totalTotal;
              // Day Invoicing
              DayInvoicing.actualMonth[dayOfMonth-1] += +Sale.totalTotal;
              // DailySales
              if (actualDayOfMonth == vm.getDayOfDB(Sale.receptionDate)) {
                for (let paymentType in vm.dataDB.SalePaymentTypeIDs) {
                  let paymentTypeID = vm.dataDB.SalePaymentTypeIDs[paymentType];
                  if (Sale.paymentTypeID == paymentTypeID) {
                    DailySales[paymentType].invoicing += Sale.totalTotal;
                    DailySales[paymentType].sales++;
                  }
                }
              } // actual day of month
            } // actual month
            // Last month
            if (lastMonth == vm.getMonthOfDB(Sale.receptionDate)) {
              // Day Invoicing
              lastMonthInvoicing += Sale.totalTotal;
              DayInvoicing.lastMonth[dayOfMonth-1] += +Sale.totalTotal;
            }

            totalInvoicing += +Sale.totalTotal;
          } // for

          vm.daysOpened = daysOpened;
          vm.statsData.DailySalesAverage.invoicing = (totalInvoicing / daysOpened);
          // diario * 100 / promedio
          vm.analyticsData.averageInvoicing.series = [parseInt(vm.statsData.DailySalesTotal.invoicing * 100 / vm.statsData.DailySalesAverage.invoicing)];

          vm.statsData.totalPurchases = totalAmountPurchases;
          vm.statsData.averagePurchase = (totalInvoicing / totalAmountPurchases).toFixed(2);
          vm.statsData.Invoicing.actualMonth = actualMonthInvoicing.toFixed(2);
          vm.statsData.Invoicing.lastMonth = lastMonthInvoicing.toFixed(2);
          vm.statsData.Invoicing.total = totalInvoicing.toFixed(2);
          vm.analyticsData.paymentType.series = paymentType;
          for (var i = 0; i < paymentType.length; i++) {
            vm.analyticsData.paymentType.analyticsData[i].counts = paymentType[i]+
            ` (${(paymentType[i] *100 / totalAmountPurchases).toFixed(1)}%)`;
          }
          vm.analyticsData.revenueComparisonLine.series[0].data = DayInvoicing.actualMonth;
          vm.analyticsData.revenueComparisonLine.series[1].data = DayInvoicing.lastMonth;
          vm.analyticsData.revenueComparisonLine;

          vm.dailySales();
        },
      });
    },
    calculateProducts(saleID) {
      const vm = this;
      this.conectToDB({
        file: 'Sales', action: 'getSaleProducts', params: { saleID: saleID },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          let Products = res.data.data;
          let totalProductsOfSale = 0;
          for (let Prod of Products) {
            totalProductsOfSale += +Prod.amount;
          }
          vm.statsData.totalProductsPurchased += +totalProductsOfSale;
        },
      });
    },
    calcultateTotalStock() {
      const vm = this;
      this.conectToDB({
        file: 'Stats', action: 'getTotalStockPrice', params: {  },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.totalStockPrice = res.data.data[0].absoluteTotal;
        },
      });
    },
    dailySales() {
      this.analyticsData.diarySales.selectedDate = this.dailySalesDaysOfDiference;
      let date = this.getActualDateToDB({day: this.dailySalesDaysOfDiference});
      let Total = {
        Cash: { invoicing: 0.0, sales: 0 },
        Card: { invoicing: 0.0, sales: 0 },
        Mercadopago: { invoicing: 0.0, sales: 0 },
      }
      for (let Sale of this.Sales) {
        if (Sale.receptionDate == date) {
          if (this.isDiarySalesOnlyEntregado && Sale.stateID != this.dataDB.SaleStateIDs.Entregado) continue;
          if (Sale.paymentTypeID == this.dataDB.SalePaymentTypeIDs.Efectivo) {
            Total.Cash.invoicing += +Sale.totalTotal;
            Total.Cash.sales++;
          } else if (Sale.paymentTypeID == this.dataDB.SalePaymentTypeIDs.Tarjeta) {
            Total.Card.invoicing += Sale.totalTotal;
            Total.Card.sales++;
          } else if (Sale.paymentTypeID == this.dataDB.SalePaymentTypeIDs.Mercadopago) {
            Total.Mercadopago.invoicing += Sale.totalTotal;
            Total.Mercadopago.sales++;
          }
        }
      }
      // Save data
      this.statsData.DailySalesTotal.invoicing = Total.Cash.invoicing + Total.Card.invoicing + Total.Mercadopago.invoicing;
      this.statsData.DailySalesTotal.sales = Total.Cash.sales + Total.Card.sales + Total.Mercadopago.sales;
      analyticsData.diarySales.series = [
        Total.Cash.invoicing,
        Total.Card.invoicing,
        Total.Mercadopago.invoicing,
      ]
      this.analyticsData.diarySales.analyticsData[0].counts = `${this.pricing(Total.Cash.invoicing)} - (${Total.Cash.sales} venta${Total.Cash.sales != 1 ? 's' : ''})`;
      this.analyticsData.diarySales.analyticsData[1].counts = `${this.pricing(Total.Card.invoicing)} - (${Total.Card.sales} venta${Total.Card.sales != 1 ? 's' : ''})`;
      this.analyticsData.diarySales.analyticsData[2].counts = `${this.pricing(Total.Mercadopago.invoicing)} - (${Total.Mercadopago.sales} venta${Total.Mercadopago.sales != 1 ? 's' : ''})`;
    },
  }, // METHODS
} // export default
</script>

<style lang="scss">
  .noChartMsg {
    height: 157px;
    line-height: 157px;
    text-align: center;
    opacity: 0.6;
    font-style: italic;
    font-size: 16px;
    margin: 35px 0;
  }
</style>
